import { render, staticRenderFns } from "./ProductWithdraw.vue?vue&type=template&id=649f934d&scoped=true"
import script from "./ProductWithdraw.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductWithdraw.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductWithdraw.vue?vue&type=style&index=0&id=649f934d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f934d",
  null
  
)

export default component.exports